
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDropDownDoubleGoogle as ObiDropDownDoubleGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-drop-down-double-google.js';
 
 
 

 
 export const ObiDropDownDoubleGoogle = createComponent({
   react: React,
   tagName: 'obi-drop-down-double-google',
   elementClass: ObiDropDownDoubleGoogleElement,
   events: {
     
   }
  });
 
 